// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { ClientProfileFragment, ClientProfileMinimalGrantorRelationshipFragment, RelationshipFragment, ClientProfileBasicFragment } from '../../graphql/ClientProfile.generated';
import { gql } from '@apollo/client';
import { ClientProfileFragmentDoc, ClientProfileMinimalGrantorRelationshipFragmentDoc, RelationshipFragmentDoc, ClientProfileBasicFragmentDoc } from '../../graphql/ClientProfile.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateClientProfileModalMutationVariables = Types.Exact<{
  clientProfileId: Types.Scalars['ID']['input'];
  householdId: Types.Scalars['ID']['input'];
  clientProfile: Types.UpdateClientProfileInput;
  clientProfileAddress: Types.UpdateClientProfileAddressInput;
  clientRelationships?: Types.InputMaybe<Array<Types.UpdateClientProfileRelationship> | Types.UpdateClientProfileRelationship>;
  hasAddress: Types.Scalars['Boolean']['input'];
  hasRelationships: Types.Scalars['Boolean']['input'];
}>;


export type UpdateClientProfileModalMutation = { __typename?: 'Mutation', updateClientProfileAddress?: { __typename?: 'ClientProfile', id: string }, updateClientProfile: (
    { __typename?: 'ClientProfile' }
    & ClientProfileFragment
  ), updateClientProfileRelationships?: Array<(
    { __typename?: 'ClientProfileRelationship' }
    & ClientProfileMinimalGrantorRelationshipFragment
  ) | null> };

export const Operations = {
  Mutation: {
    UpdateClientProfileModal: 'UpdateClientProfileModal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UpdateClientProfileModalDocument = gql`
    mutation UpdateClientProfileModal($clientProfileId: ID!, $householdId: ID!, $clientProfile: UpdateClientProfileInput!, $clientProfileAddress: UpdateClientProfileAddressInput!, $clientRelationships: [UpdateClientProfileRelationship!], $hasAddress: Boolean!, $hasRelationships: Boolean!) {
  updateClientProfileAddress(id: $clientProfileId, input: $clientProfileAddress) @include(if: $hasAddress) {
    id
  }
  updateClientProfile(id: $clientProfileId, input: $clientProfile) {
    ...ClientProfile
  }
  updateClientProfileRelationships(
    householdId: $householdId
    updateRelationships: $clientRelationships
  ) @include(if: $hasRelationships) {
    ...ClientProfileMinimalGrantorRelationship
  }
}
    ${ClientProfileFragmentDoc}
${ClientProfileMinimalGrantorRelationshipFragmentDoc}`;
export type UpdateClientProfileModalMutationFn = Apollo.MutationFunction<UpdateClientProfileModalMutation, UpdateClientProfileModalMutationVariables>;

/**
 * __useUpdateClientProfileModalMutation__
 *
 * To run a mutation, you first call `useUpdateClientProfileModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientProfileModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientProfileModalMutation, { data, loading, error }] = useUpdateClientProfileModalMutation({
 *   variables: {
 *      clientProfileId: // value for 'clientProfileId'
 *      householdId: // value for 'householdId'
 *      clientProfile: // value for 'clientProfile'
 *      clientProfileAddress: // value for 'clientProfileAddress'
 *      clientRelationships: // value for 'clientRelationships'
 *      hasAddress: // value for 'hasAddress'
 *      hasRelationships: // value for 'hasRelationships'
 *   },
 * });
 */
export function useUpdateClientProfileModalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientProfileModalMutation, UpdateClientProfileModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientProfileModalMutation, UpdateClientProfileModalMutationVariables>(UpdateClientProfileModalDocument, options);
      }
export type UpdateClientProfileModalMutationHookResult = ReturnType<typeof useUpdateClientProfileModalMutation>;
export type UpdateClientProfileModalMutationResult = Apollo.MutationResult<UpdateClientProfileModalMutation>;
export type UpdateClientProfileModalMutationOptions = Apollo.BaseMutationOptions<UpdateClientProfileModalMutation, UpdateClientProfileModalMutationVariables>;